import { actions } from 'react/api/actions/monitor';
import { formatInforMarkerTruck } from 'react/utils/routeProgressBarUtils';

export const initialState = {
  pendingOrderRow: {
    open: false
  },
  isRequestingRoutes: false,
  routePanel: {
    isOpen: false,
    title: '',
    route: null
  },
  routesOnMap: [],
  focusedRouteOnMap: null,
  performingActionOnMap: false,
  equipmentFilters: ['noCommunication', 'stopped', 'moving', 'turnedOff']
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.request:
      return { ...state, isRequestingRoutes: true };
    case actions.paginate:
      return { ...state };
    case actions.requestSuccess:
      return { ...state, isRequestingRoutes: false };
    case actions.togglePendingOrderRow:
      return { ...state, pendingOrderRow: { open: action.payload.open } };
    case actions.clearState:
      return initialState;
    case actions.openRoutePanel: {
      const { route: routeView } = action.payload;

      const formattedTitle = formatInforMarkerTruck(routeView);
      const dateFormatted = Monet.Format.Date
        .formatToLocale(routeView.route.date, { dayMonthOnly: true });

      const routeLabel = `${formattedTitle.toUpperCase()} (${dateFormatted})`;

      return {
        ...state,
        routePanel: {
          isOpen: true,
          route: routeView,
          title: routeLabel
        }
      };
    }
    case actions.updateRoutePanelTitle: {
      const { route: routeView } = state.routePanel;

      if (!routeView) return state;

      const formattedTitle = formatInforMarkerTruck(routeView);
      const dateFormatted = Monet.Format.Date
        .formatToLocale(routeView.route.date, { dayMonthOnly: true });

      const routeLabel = `${formattedTitle.toUpperCase()} (${dateFormatted})`;

      return {
        ...state,
        routePanel: {
          ...state.routePanel,
          title: routeLabel
        }
      };
    }
    case actions.closeRoutePanel: {
      return {
        ...state,
        routePanel: {
          isOpen: false,
          route: null
        }
      };
    }
    case actions.updateRoutesOnMap: {
      const routesOnMap = action.payload;

      if (!routesOnMap) return state;

      return {
        ...state,
        routesOnMap
      };
    }
    case actions.toggleMapState: {
      return {
        ...state,
        performingActionOnMap: !state.performingActionOnMap
      };
    }
    case actions.selectRouteOnMap: {
      const { routeId } = action.payload;

      return {
        ...state,
        focusedRouteOnMap: routeId
      };
    }
    case actions.removeFocusedRouteOnMap: {
      return {
        ...state,
        focusedRouteOnMap: null
      };
    }
    case actions.updateEquipmentFilters: {
      const equipmentFilters = action.payload;

      return {
        ...state,
        equipmentFilters
      };
    }
    case actions.resetEquipmentFilters: {
      return {
        ...state,
        equipmentFilters: ['noCommunication', 'stopped', 'moving', 'turnedOff']
      };
    }
    default:
      return state;
  }
};
